import { render, staticRenderFns } from "./RipeavShadow.vue?vue&type=template&id=fce73ada&scoped=true&"
import script from "./RipeavShadow.vue?vue&type=script&lang=js&"
export * from "./RipeavShadow.vue?vue&type=script&lang=js&"
import style0 from "./RipeavShadow.vue?vue&type=style&index=0&id=fce73ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce73ada",
  null
  
)

export default component.exports